import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator,
} from '@mui/lab'
import { Button, Typography } from '@mui/material'
import { format } from 'date-fns'
import { useState } from 'react'

export interface ProcessStatusTimelineProps {
    history: ProcessStatusTimelineItem[]
    initialLimit?: number
}

export interface ProcessStatusTimelineItem {
    processStatus?: string
    createdByUserPreferredName?: string
    createdAt?: Date
}

const ProcessStatusTimeline: React.FC<ProcessStatusTimelineProps> = ({
    history,
    initialLimit = 2,
}) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const hasMore = history.length > initialLimit
    const visibleItems = isExpanded ? history : history.slice(0, initialLimit)
    const hiddenCount = history.length - initialLimit

    return (
        <>
            <Timeline sx={{ marginBottom: 0 }}>
                {visibleItems.map((item, index) => {
                    const isFirstItem = index === 0
                    const isLastItem = index === visibleItems.length - 1
                    return (
                        <TimelineItem key={`${item.processStatus}_${index}`}>
                            <TimelineOppositeContent
                                color="text.secondary"
                                sx={{ fontSize: '0.75rem' }}
                            >
                                {item.processStatus}
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                                <TimelineDot
                                    variant={
                                        isFirstItem ? 'outlined' : 'filled'
                                    }
                                />
                                {!isLastItem && <TimelineConnector />}
                            </TimelineSeparator>
                            <TimelineContent>
                                <Typography sx={{ fontSize: '0.75rem' }}>
                                    {item.createdByUserPreferredName ??
                                        'Unknown User'}
                                </Typography>
                                <Typography
                                    sx={{ fontSize: '0.625rem' }}
                                    color="GrayText"
                                >
                                    {format(
                                        item.createdAt ?? new Date(),
                                        'MM/dd/yy'
                                    )}
                                </Typography>
                            </TimelineContent>
                        </TimelineItem>
                    )
                })}
            </Timeline>
            {hasMore && (
                <Button
                    variant="text"
                    size="small"
                    onClick={() => setIsExpanded(!isExpanded)}
                    sx={{ display: 'block', ml: 'auto', mr: 2 }}
                >
                    {isExpanded ? 'Show less' : `Show ${hiddenCount} more`}
                </Button>
            )}
        </>
    )
}

export default ProcessStatusTimeline
